import { firstValueFrom } from 'rxjs';
import type { ConcreteUniverse } from 'src/contracts/universe';
import { getDefaultUniverse as getDefaultUniverseObs } from 'src/lib/universes';

export async function getDefaultUniverse(): Promise<ConcreteUniverse> {
    return firstValueFrom(getDefaultUniverseObs());
}
